
//-
import { useTranslation } from "react-i18next";
import "../Styles/Epub.css";
import { useState, useEffect, useRef } from "react";
import { EpubReader } from "../Components/EpubReader";
import * as CryptoJS from "crypto-js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $, { data } from "jquery";
import EpubServices from "../Services/Epub";
import plus from "../Images/plus.svg";
import min from "../Images/min.svg";
import reload from "../Images/refresh.svg";
import close from "../Images/close.svg";
import BooksService from "../Services/Books";
import VideoService from "../Services/VideoPlayer";
import Loading from "../Components/Loading";

export enum BookContentType {
  books = "books",
  kalyan = "kalyan",
  kalpatru = "kalpatru",
  magazine = "magazine",
  vivek = "vivek",
}

interface bookmark {
  id: number;
  name: string;

}

const EpubPage = () => {
  var signKey = localStorage.getItem("SignKey");
  var token = localStorage.getItem("Token");
  var userid = localStorage.getItem("UserId");

  console.log("userid in EpubPage:", userid);
  console.log("Token in EpubPage:", token && token.length > 8 ? `${token.substring(0, 4)}...${token.substring(token.length - 4)}` : token);

  // If token or userid missing/invalid -> redirect immediately (before hooks run)
  const _isInvalidAuthImmediate = (v: any) =>
    v === null || v === undefined || v === "null" || v === "undefined" || v === "";

  if (_isInvalidAuthImmediate(userid) || _isInvalidAuthImmediate(token)) {
    const from = window.location.pathname;
    const to = from.replace(/^\/reader/, "") || "/";
    console.log(`Redirecting from ${from} to ${to} because invalid userid/token:`, { userid, token });
    // Force a full-page replacement (immediate) instead of using Navigate hook
    // We avoid calling hooks conditionally and still perform an instant redirect
    window.location.replace(to);
  }

  var currentdate = new Date();
  var todayDate = currentdate
    .toISOString()
    .replace("T", " ")
    .substring(0, 16)
    .replace(".", "")
    .replace(":", "")
    .replace("-", "")
    .replace(" ", "")
    .replace("-", "");

  var url_file = "";
  var xhr = new XMLHttpRequest();
  const epubViewStyles = {
    viewHolder: {
      position: "relative",
      height: "100%",
      width: "100%",
    },
    view: {
      height: "100%",
    },
  };

  const [size, setSize] = useState<number | any>(100);
  const { slug } = useParams();

  let renditionRef = useRef<any>(undefined);
  const tocRef = useRef<any>(undefined);
  const serverTocRef = useRef<any[] | undefined>(undefined);

  const getSecureKey = (url: any) => {
    let securekey =
      userid +
      "|" +
      todayDate +
      "|" +
      decodeURI(url) +
      "|" +
      signKey +
      "|Website";

    var hash = CryptoJS?.HmacSHA256(securekey, signKey as any);
    securekey = CryptoJS?.enc?.Base64?.stringify(hash);
    return encodeURI(securekey);
  };

  const [page, setPage] = useState("");


  const changeSize = (newSize: any) => {
    setSize(newSize);
  };
  const isShlokWithBracket = (text: string): boolean => {
    const trimmed = text?.trim();
    return (
      trimmed?.startsWith("(") &&
      trimmed?.includes("श्लोक") || trimmed?.startsWith("श्लोक")
    );
  };
  const CurrentTheme = localStorage.getItem("epub-theme");

  const [colortheme, setTheme] = useState<any | String>(undefined);
  const [fontcolor, setFontColor] = useState<any | String>(undefined);
  const [themecolor, setThemeColor] = useState<any>(
    localStorage.getItem("epub-theme")
  );
  const [subHeadings, setSubHeadings] = useState<string>("");
  const [saveSubHead, setSaveSubHead] = useState<string>("");
  const [subHead, setSubHead] = useState<any>("");

  const manualSelectUntilRef = useRef<number>(0);
  const MANUAL_GUARD_MS = 700;

  const findTocEntry = (tocItems: any[], hrefToMatch: string): any => {
    if (!tocItems || !hrefToMatch) return null;

    const normalize = (a: string, b: string) => {
      if (!a || !b) return false;
      try {

        const clean = (s: string) => s.split("#")[0].split("?")[0];
        const A = clean(a).toLowerCase();
        const B = clean(b).toLowerCase();
        if (A === B) return true;
        if (B.includes(A)) return true;
        if (A.endsWith(B) || B.endsWith(A)) return true;

        const aName = A.split("/").pop();
        const bName = B.split("/").pop();
        return aName === bName;
      } catch {
        return false;
      }
    };

    for (let item of tocItems) {
      if (item?.href && normalize(item.href, hrefToMatch)) {
        return { parentLabel: undefined, label: item.label, tocItem: item };
      }

      if (item?.subitems && item.subitems.length > 0) {
        for (let sub of item.subitems) {
          if (sub?.href && normalize(sub.href, hrefToMatch)) {
            return { parentLabel: item.label, label: sub.label, tocItem: sub };
          }
        }

        const deeper = findTocEntry(item.subitems, hrefToMatch);
        if (deeper) {
          return {
            parentLabel: deeper.parentLabel || item.label,
            label: deeper.label,
            tocItem: deeper.tocItem,
          };
        }
      }
    }
    return null;
  };
  const normalize = (a: string, b: string) => {
    if (!a || !b) return false;
    try {
      const clean = (s: string) => {
        return s.split("#")[0].split("?")[0].toLowerCase();
      };
      const A = clean(a);
      const B = clean(b);

      return A === B || A.includes(B) || B.includes(A);
    } catch {
      return false;
    }
  };

  // Build a mapping from normalized srcFile to PlayOrder from server TOC
  const buildPlayOrderMap = (serverToc: any[]): Map<string, number> => {
    const map = new Map<string, number>();
    if (!serverToc || serverToc.length === 0) return map;

    serverToc.forEach((node: any) => {
      if (node.srcFile && node.playOrder !== undefined) {
        // Normalize: lowercase, decode URI, remove path prefixes
        const normalized = decodeURIComponent(node.srcFile)
          .toLowerCase()
          .split("/")
          .pop() || "";
        map.set(normalized, node.playOrder);
      }
    });
    return map;
  };

  const getPlayOrder = (serverToc: any[], href: string): number | null => {
    if (!serverToc || !href) return null;

    try {
      // Normalize the href: remove anchors, query params, decode URI, get filename only
      let normalized = href.split("#")[0].split("?")[0];
      normalized = decodeURIComponent(normalized).toLowerCase();
      const filename = normalized.split("/").pop() || "";

      // Build map and lookup
      const playOrderMap = buildPlayOrderMap(serverToc);
      return playOrderMap.get(filename) || null;
    } catch (err) {
      console.error("getPlayOrder error:", err);
      return null;
    }
  };
  // track whether we've loaded bookmarks at least once for this rendition
  const bookmarksLoadedRef = useRef<boolean>(false);

  // Robust bookmark check used by the UI icon and click handlers
  const isBookmarked = (loc: any) => {
    if (!loc || !showBKdata) return false;
    try {
      return showBKdata.some((i: any) => {
        if (!i) return false;
        if (i.cfi && i.cfi === loc) return true;
        if (i.href && normalize(i.href, loc)) return true;
        if (i.cfi && normalize(i.cfi, loc)) return true;
        return false;
      });
    } catch (err) {
      return false;
    }
  };
  // const handleRelocated = (relocated: any) => {
  //   try {
  //     const newLocation = relocated?.start?.cfi || relocated?.start?.location || undefined;
  //     setLocation(newLocation);

  //     if (manualSelectUntilRef.current && Date.now() < manualSelectUntilRef.current) {
  //       return;
  //     }

  //     const href = relocated?.start?.href || relocated?.start?.indexHref || "";
  //     const displayed = relocated?.start?.displayed;

  //     setPage(
  //       `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"}`
  //     );

  //     const toc = tocRef.current;
  //     if (toc && href) {
  //       const found = findTocEntry(toc, href);

  //       if (found) {
  //      
  //         if (found.parentLabel) {
  //           setLastName(found.parentLabel);
  //           setSubHeadings(found.label);
  //           handleSetSaveSubHead(found.label); // ← Save to localStorage
  //         } 
  //      
  //         else if (found.tocItem?.subitems?.length > 0) {
  //        
  //           const activeSubItem = found.tocItem.subitems.find((sub: any) => {
  //             return normalize(sub.href, href);
  //           });

  //           if (activeSubItem) {
  //             setLastName(found.label);
  //             setSubHeadings(activeSubItem.label);
  //             handleSetSaveSubHead(activeSubItem.label);
  //           } else {
  //     
  //             setLastName(found.label);
  //             setSubHeadings("");
  //             handleSetSaveSubHead("");
  //           }
  //         } 
  //         // 3. सिंपल chapter
  //         else {
  //           setLastName(found.label);
  //           setSubHeadings("");
  //           handleSetSaveSubHead("");
  //         }
  //       } else {
  //         // fallback अगर TOC match न हो
  //         if (Array.isArray(toc) && typeof relocated?.start?.index === "number") {
  //           const chapter = toc[relocated.start.index];
  //           setLastName(chapter?.label || "");
  //           setSubHeadings("");
  //           handleSetSaveSubHead("");
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.error("handleRelocated error:", err);
  //   } finally {
  //     manualSelectUntilRef.current = 0;
  //   }
  // };


  const handleRelocated = (relocated: any) => {
    const timeStamp = Date.now();
    console.log("Relocated event:", { timeStamp, relocated });

    try {
      const newLocation = relocated?.start?.cfi || relocated?.start?.location || undefined;
      setLocation(newLocation);

      if (manualSelectUntilRef.current && Date.now() < manualSelectUntilRef.current) {
        return;
      }

      const href = relocated?.start?.href || relocated?.start?.indexHref || "";
      const displayed = relocated?.start?.displayed;

      setPage(
        `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"}`
      );

      const toc = tocRef.current;
      if (toc && href) {
        const found = findTocEntry(toc, href);

        if (found) {
          if (found.parentLabel) {
            setLastName(found.parentLabel);

            if (found.label && !isShlokWithBracket(found.label)) {
              setSubHeadings(found.label.trim());
              handleSetSaveSubHead(found.label.trim());
            } else {
              setSubHeadings("");
              handleSetSaveSubHead("");
            }
          }
          else if (found.tocItem?.subitems?.length > 0) {
            const activeSubItem = found.tocItem.subitems.find((sub: any) => {
              return normalize(sub.href, href);
            });

            if (activeSubItem && !isShlokWithBracket(activeSubItem.label)) {
              setLastName(found.label);
              setSubHeadings(activeSubItem.label.trim());
              handleSetSaveSubHead(activeSubItem.label.trim());
            } else {
              setLastName(found.label);
              setSubHeadings("");
              handleSetSaveSubHead("");
            }
          }
          else {
            setLastName(found.label);
            setSubHeadings("");
            handleSetSaveSubHead("");
          }
        }
        else {
          setLastName("");
          setSubHeadings("");
          handleSetSaveSubHead("");
        }
      }
    } catch (err) {
      console.error("handleRelocated error:", err);
    } finally {
      manualSelectUntilRef.current = 0;
    }
  };

  const locationChanged = (epubcifi: any) => {
    const timeStamp = Date.now();
    console.log("locationChanged event:", { timeStamp, epubcifi });
    setLocation(epubcifi);
    if (renditionRef?.current && tocRef?.current) {
      const { displayed, href } = renditionRef?.current?.location?.start;
      const index = renditionRef?.current?.location?.start?.index;
      setPage(
        `Page ${displayed?.page} of ${displayed?.total} in chapter ${href ? href : "n/a"
        }`
      );
    }
  };

  const [toast, setToast] = useState<{ show: boolean; message: string }>({
    show: false,
    message: "",
  });
  const { t } = useTranslation();

  const [lastName, setLastName] = useState("");
  const [savedBookMark, setSavedBookMark] = useState<boolean>(false);
  const [bookName, setBookName] = useState<string>("");
  const [showBKdata, setShowBKdata] = useState<bookmark[] | undefined | any>(
    undefined
  );
  const [showdata, setShowdata] = useState<boolean>(false);
  const [lengthofbkm, setLengthofbkm] = useState<boolean>(false);

  const locationDetail = useLocation();
  const state = locationDetail?.state as {
    bookDetailId: string;
    kalyanDetailId: string;
    kalpatrauDetailId: string;
    magazineDetailId: string;
    vivekvaniDetailId: string;
    bookName: string;
    chapterName: string;
    slug: string;
    type: BookContentType;
    titleName: string;
    location: string;
    tocNode?: any;
    reload: string;
  };

  const getUrlBytype = (type: BookContentType) => {
    let value = "";
    switch (type) {
      case BookContentType.books:
        value = `books/${state?.bookDetailId}`;
        break;
      case BookContentType.kalyan:
        value = `kalyans/${state?.kalyanDetailId}`;
        break;
      case BookContentType.kalpatru:
        value = `kalyanskalpataru/${state?.kalpatrauDetailId}`;
        break;
      case BookContentType.magazine:
        value = `MonthlyMagazines/${state?.magazineDetailId}`;
        break;
      case BookContentType.vivek:
        value = `vivekVanis/${state?.vivekvaniDetailId}`;
        break;
      default:
        break;
    }
    return value;
  };

  const [url, setUrl] = useState(
    `${process.env.REACT_APP_API_URL}/api/${getUrlBytype(
      state.type
    )}/epubstrem/`
  );

  const [location, setLocation] = useState<any>(undefined);
  const [isSaving, setIsSaving] = useState(false);

  const head = {
    Authorization: "Bearer " + token,
    "X-Signature": getSecureKey(url),
    "X-Plateform": "1",
    "X-Value": todayDate,
  };

  function clickOnTheme(disp: boolean) {
    if (disp) {
      $("#divTheme").removeClass("hidetheme");
    } else {
      $("#divTheme").addClass("hidetheme");
    }
  }

  const saveLstPositionAndClose = () => {
    const positionKey = state?.bookDetailId
      ? "lastposition"
      : state?.kalyanDetailId
        ? "kalyanlastposition"
        : state?.kalpatrauDetailId
          ? "kalyankalpatarulastposition"
          : state?.magazineDetailId
            ? "monthlymagazinelastposition"
            : state?.vivekvaniDetailId
              ? "vivekvanilastposition"
              : "lastposition";

    const detailId =
      state?.bookDetailId ||
      state?.kalyanDetailId ||
      state?.kalpatrauDetailId ||
      state?.magazineDetailId ||
      state?.vivekvaniDetailId;

    const href = renditionRef.current?.location?.start?.href || "";
    const playorder = state?.bookDetailId && serverTocRef.current
      ? getPlayOrder(serverTocRef.current, href)?.toString() || ""
      : "";

    console.log("saving " + detailId, location, size, playorder);

    setIsSaving(true);
    return EpubServices.SaveLastPositionAndClose(
      positionKey,
      detailId,
      location,
      size,
      playorder
    )
      .then((res) => {
        // saved
        console.log("saved " + detailId, res);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };


  const locationRef = useRef(location);
  const sizeRef = useRef(size);

  useEffect(() => {
    locationRef.current = location;
    sizeRef.current = size;
  }, [location, size]);

  useEffect(() => {
    return () => {
      const positionKey = state?.bookDetailId
        ? "lastposition"
        : state?.kalyanDetailId
          ? "kalyanlastposition"
          : state?.kalpatrauDetailId
            ? "kalyankalpatarulastposition"
            : state?.magazineDetailId
              ? "monthlymagazinelastposition"
              : state?.vivekvaniDetailId
                ? "vivekvanilastposition"
                : "lastposition";

      const detailId =
        state?.bookDetailId ||
        state?.kalyanDetailId ||
        state?.kalpatrauDetailId ||
        state?.magazineDetailId ||
        state?.vivekvaniDetailId;

      if (detailId && locationRef.current) {
        const href = renditionRef.current?.location?.start?.href || "";
        const playorder = state?.bookDetailId && serverTocRef.current
          ? getPlayOrder(serverTocRef.current, href)?.toString() || ""
          : "";
        EpubServices.SaveLastPositionAndClose(
          positionKey,
          detailId,
          locationRef.current,
          sizeRef.current,
          playorder
        ).then((res) => {
          // saved
        });
      }
    };
  }, [state]);


  useEffect(() => {
    if (renditionRef.current) {
      renditionRef.current.themes.fontSize(`${size}%`);
    }
  }, [size]);

  useEffect(() => {
    // set book name from navigation state (prefer explicit bookName, fallback to titleName)
    if (state?.bookName) {
      setBookName(state.bookName);
    } else if (state?.titleName) {
      setBookName(state.titleName);
    }
    // If a location is provided via navigation state (bookmarks / Continue Reading / TOC), use it.
    if (state?.tocNode || state?.location) {
      let targetLocation = state?.location;

      // If we have a tocNode, ignore state.location and cfi, 
      // and construct location from srcFile and srcAnchor
      if (state?.tocNode) {
        const { srcFile, srcAnchor } = state.tocNode;
        if (srcFile) {
          targetLocation = srcAnchor ? `${srcFile}#${srcAnchor}` : srcFile;
        }
      }

      if (targetLocation) {
        setLocation(targetLocation);
      }



      if (state?.chapterName) {
        setLastName(state?.chapterName);
        setSubHeadings("");
      }
    }
    // Note: we intentionally do NOT call the last-position API from this component.
  }, [state?.location, state?.bookDetailId, state?.tocNode]);

  // Fetch server navigation details (TOC with PlayOrder) for Books only
  useEffect(() => {
    if (state?.bookDetailId) {
      BooksService.getNavigationDetails(state.bookDetailId)
        .then((res: any) => {
          if (res?.status && res?.result?.navigationTree) {
            serverTocRef.current = res.result.navigationTree;
            console.log("Server TOC loaded with PlayOrder:", serverTocRef.current?.length || 0, "nodes");
          }
        })
        .catch((err) => {
          console.error("Failed to load navigation details:", err);
        });
    }
  }, [state?.bookDetailId]);

  // No syncing from API last-position; rely only on `state.location` and user actions.

  useEffect(() => {
    clickOnTheme(false);
  }, []);

  useEffect(() => {
    if (renditionRef.current) {
      renditionRef.current.themes.register("custom", {
        body: {
          // background: colortheme,
          // background: colortheme,
          color: fontcolor,
        },
      });
      renditionRef.current.themes.select("custom");
      if (themecolor === "black") {
        localStorage.setItem("epub-theme", "black");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("theme-grey");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-grey");
        $("#test-div").addClass("theme-black");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-grey");
        $("#test-toc-div").addClass("theme-black");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-grey");
        $("#test-toc-div button").addClass("theme-black");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-grey");
        $("#tocwidth").addClass("theme-black");

        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#000000",
            setFontColor: "#ffffff",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
          img: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
        });
      } else if (themecolor === "grey") {
        localStorage.setItem("epub-theme", "grey");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("theme-black");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-grey");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-grey");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-grey");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-grey");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#464646",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
          img: {
            "-webkit-filter": "invert(1) hue-rotate(180deg)",
            filter: "invert(1) hue-rotate(180deg)",
          },
        });
      } else if (themecolor === "ivory") {
        localStorage.setItem("epub-theme", "ivory");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("titlebar_color");

        $("#test-div").removeClass("theme-white");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-ivory");

        $("#test-toc-div").removeClass("theme-white");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-ivory");

        $("#test-toc-div button").removeClass("theme-white");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-ivory");

        $("#tocwidth").removeClass("theme-white");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-ivory");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#fffcda",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
          img: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
        });
      } else if (themecolor === "white") {
        localStorage.setItem("epub-theme", "white");
        $("#titlebar").removeClass("theme-grey");
        $("#titlebar").removeClass("theme-black");
        $("#titlebar").removeClass("titlebar_color");
        $("#titlebar").addClass("titlebar_color");

        $("#test-div").removeClass("theme-grey");
        $("#test-div").removeClass("theme-ivory");
        $("#test-div").removeClass("theme-black");
        $("#test-div").addClass("theme-white");

        $("#test-toc-div").removeClass("theme-grey");
        $("#test-toc-div").removeClass("theme-ivory");
        $("#test-toc-div").removeClass("theme-black");
        $("#test-toc-div").addClass("theme-white");

        $("#test-toc-div button").removeClass("theme-grey");
        $("#test-toc-div button").removeClass("theme-ivory");
        $("#test-toc-div button").removeClass("theme-black");
        $("#test-toc-div button").addClass("theme-white");

        $("#tocwidth").removeClass("theme-grey");
        $("#tocwidth").removeClass("theme-ivory");
        $("#tocwidth").removeClass("theme-black");
        $("#tocwidth").addClass("theme-white");
        renditionRef?.current?.themes?.default({
          // "p.TXT": { color: `${fontcolor}!important` },
          "*": {
            "-webkit-transition": "transform 0.5s ease",
            "-moz-transition": "tranform 0.5s ease",
            "-o-transition": "transform 0.5s ease",
            "-ms-transition": "transform 0.5s ease",
            transition: "transform 0.5s ease",
            "-webkit-touch-callout": "none",
            "-webkit-user-select": "none",
            "-khtml-user-select": "none",
            "-moz-user-select": "none",
            "-ms-user-select": "none",
            "user-select": "none",
          },
          body: {
            // background: "#ffffff",
            "overflow-wrap": "break-word",
            hyphens: "auto",
          },
          html: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
          img: {
            "-webkit-filter": "invert(0) hue-rotate(0)",
            filter: "invert(0) hue-rotate(0)",
          },
        });
      }
    }
    // return GetSignKey();
  }, [
    colortheme,
    fontcolor,
    state?.bookDetailId,
    CurrentTheme,
    themecolor,
    localStorage.getItem("epub-theme"),
  ]);
  const [finalName, setFinalName] = useState<string>("");

  const navigate = useNavigate();


  const BookId = state?.bookDetailId;
  const KalyanId = state?.kalyanDetailId;
  const KalpataruId = state?.kalpatrauDetailId;
  const MagazineId = state?.magazineDetailId;
  const VivekId = state?.vivekvaniDetailId;

  const closebutton = () => {
    console.log("closebutton", BookId);
    if (BookId) {
      navigate(`/books/` + state.slug, {
        state: { bookId: state?.bookDetailId },
      });
    }
    if (KalyanId) {
      navigate(`/kalyan/` + state.slug, {
        state: { kalyanId: state?.kalyanDetailId },
      });
    }
    if (KalpataruId) {
      navigate(`/kalyanakalpataru/` + state.slug, {
        state: { kalpatruId: state?.kalpatrauDetailId },
      });
    }
    if (MagazineId) {
      navigate(`/geetgovind/` + state.slug, {
        state: { MonthId: state?.magazineDetailId },
      });
    }
    if (VivekId) {
      navigate(`/vivekvani/` + state?.slug, {
        state: { vivekId: state?.vivekvaniDetailId },
      });
    }
  };

  const [bookmarkLimit] = useState(10);

  const SaveBookMark = async () => {
    if (showBKdata?.length < bookmarkLimit) {
      let res;
      if (state?.bookDetailId) {
        res = await EpubServices.savebookmark(
          "bookmarks",
          state?.bookDetailId,
          location,
          finalName || lastName
        );
      } else if (state?.kalyanDetailId) {
        res = await EpubServices.savebookmark(
          "kalyanbookmarks",
          state?.kalyanDetailId,
          location,
          finalName
        );
      } else if (state?.kalpatrauDetailId) {
        res = await EpubServices.savebookmark(
          "kalyankalpatarubookmarks",
          state?.kalpatrauDetailId,
          location,
          finalName
        );
      } else if (state?.magazineDetailId) {
        res = await EpubServices.savebookmark(
          "monthlymagazinebookmarks",
          state?.magazineDetailId,
          location,
          finalName
        );
      } else if (state?.vivekvaniDetailId) {
        res = await EpubServices.savevivekvanimark(
          state?.vivekvaniDetailId,
          location,
          finalName
        );
      }

      if (res?.status) {
        setSavedBookMark(!savedBookMark);
        showNotification(
          localStorage.getItem("lan") === "hindi"
            ? "बुकमार्क को सफलतापूर्वक जोड़ा गया |"
            : "Bookmark added successfully"
        );
      }
    } else {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "आपने इस पुस्तक के लिए अधिकतम बुकमार्क सीमा पार कर ली है। नए जोड़ने के लिए कृपया कुछ बुकमार्क हटाएँ |"
          : "You have exceeded the maximum bookmark limit fir this book. Please delete a few to add new ones"
      );
    }
  };

  const showNotification = (message: any) => {
    setToast({ show: true, message });
    const cleartimeout = setTimeout(() => {
      setToast({ show: false, message: "" });
    }, 2000);
    return () => clearTimeout(cleartimeout);
  };
  const getBookKey = () => {
    return (
      state?.bookDetailId ||
      state?.kalyanDetailId ||
      state?.kalpatrauDetailId ||
      state?.magazineDetailId ||
      state?.vivekvaniDetailId ||
      "unknown"
    );
  };


  // const handleSetSaveSubHead = (subHead: string) => {
  //   const key = `epub-subhead-${getBookKey()}`;
  //   localStorage.setItem(key, subHead);     
  //   setSaveSubHead(subHead);                
  // };
  const handleSetSaveSubHead = (subHead: string) => {
    if (!subHead || isShlokWithBracket(subHead)) {
      const key = `epub-subhead-${getBookKey()}`;
      localStorage.removeItem(key);
      setSaveSubHead("");
      return;
    }

    const key = `epub-subhead-${getBookKey()}`;
    localStorage.setItem(key, subHead.trim());
    setSaveSubHead(subHead.trim());
  };

  // useEffect(() => {
  //   const key = `epub-subhead-${getBookKey()}`;
  //   const saved = localStorage.getItem(key);
  //   if (saved) {
  //     setSaveSubHead(saved);                
  //   }
  // }, [state]); 

  useEffect(() => {
    const key = `epub-subhead-${getBookKey()}`;
    const saved = localStorage.getItem(key);

    if (saved && isShlokWithBracket(saved)) {
      localStorage.removeItem(key);
      setSaveSubHead("");
    } else if (saved) {
      setSaveSubHead(saved.trim());
    }
  }, [state]);

  const RemoveBookMark = async () => {
    let res;
    if (state?.bookDetailId) {
      res = await EpubServices.removebookmark(
        "bookmarks",
        state?.bookDetailId,
        location
      );
    }
    if (state?.kalyanDetailId) {
      res = await EpubServices.removebookmark(
        "kalyanbookmarks",
        state?.kalyanDetailId,
        location
      );
    }
    if (state?.kalpatrauDetailId) {
      res = await EpubServices.removebookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId,
        location
      );
    }
    if (state?.magazineDetailId) {
      res = await EpubServices.removebookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId,
        location
      );
    }
    if (state?.vivekvaniDetailId) {
      res = await EpubServices.deletevivekmark(
        "vivekvanimarks",
        state?.vivekvaniDetailId,
        location
      );
    }

    if (res?.status) {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "बुकमार्क को सफलतापूर्वक हटाया गया |"
          : "Bookmark removed successfully"
      );
    }
  };

  const getSavedBook = () => {
    if (state.bookDetailId) {
      EpubServices.getbookmark("bookmarks", state?.bookDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);
            
            res.result.length > 0
                ? setLengthofbkm(true)
                : setLengthofbkm(false);
            
          }
        }
      );
    }
    if (state?.kalyanDetailId) {
      EpubServices.getbookmark("kalyanbookmarks", state?.kalyanDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);
            
            res.result.length > 0
                ? setLengthofbkm(true)
                : setLengthofbkm(false);
            
          }
        }
      );
    }
    if (state?.kalpatrauDetailId) {
      EpubServices.getbookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId
      ).then((res: any) => {
        if (res.status) {
          setShowBKdata(res?.result);
          res.result.length > 0
              ? setLengthofbkm(true)
              : setLengthofbkm(false);          
        }
      });
    }
    if (state?.magazineDetailId) {
      EpubServices.getbookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId
      ).then((res: any) => {
        if (res.status) {
          setShowBKdata(res?.result);
          res.result.length > 0
              ? setLengthofbkm(true)
              : setLengthofbkm(false);
          
        }
      });
    }
    if (state?.vivekvaniDetailId) {
      EpubServices.getvivekvanimark(state?.vivekvaniDetailId).then(
        (res: any) => {
          if (res.status) {
            setShowBKdata(res?.result);
            res.result.length > 0
                ? setLengthofbkm(true)
                : setLengthofbkm(false);
            
          }
        }
      );
    }
  };

  useEffect(() => {
    getSavedBook();
  }, [savedBookMark]);

  const handleDelete = async (dataCfi: any) => {
    let res;
    if (state?.bookDetailId) {
      res = await EpubServices.removebookmark(
        "bookmarks",
        state?.bookDetailId,
        dataCfi
      );
    }
    if (state?.kalyanDetailId) {
      res = await EpubServices.removebookmark(
        "kalyanbookmarks",
        state?.kalyanDetailId,
        dataCfi
      );
    }
    if (state?.kalpatrauDetailId) {
      res = await EpubServices.removebookmark(
        "kalyankalpatarubookmarks",
        state?.kalpatrauDetailId,
        dataCfi
      );
    }
    if (state?.magazineDetailId) {
      res = await EpubServices.removebookmark(
        "monthlymagazinebookmarks",
        state?.magazineDetailId,
        dataCfi
      );
    }
    if (state?.vivekvaniDetailId) {
      res = await EpubServices.deletevivekmark(
        "vivekvanimarks",
        state?.vivekvaniDetailId,
        dataCfi
      );
    }

    if (res?.status) {
      setSavedBookMark(!savedBookMark);
      showNotification(
        localStorage.getItem("lan") === "hindi"
          ? "बुकमार्क को सफलतापूर्वक हटाया गया |"
          : "Bookmark removed successfully"
      );
    }
  };

  // useEffect(() => {
  //   if (state?.bookDetailId) {
  //     BooksService.getBookDetail(state?.bookDetailId, "").then((res: any) => {
  //       setBookName(res?.result?.name);
  //     });
  //   }
  //   if (state?.kalyanDetailId) {
  //     KalyansServices.getcurrentKalyan(state?.kalyanDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.kalpatrauDetailId) {
  //     KalpataruServices.getcurrentKalpatarul(state?.kalpatrauDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.magazineDetailId) {
  //     GeetGovindServices.getcurrentMagazine(state?.magazineDetailId, "").then(
  //       (res) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  //   if (state?.vivekvaniDetailId) {
  //     VivekService.VikekDetailService(state.vivekvaniDetailId, "").then(
  //       (res: any) => {
  //         setBookName(res?.result?.name);
  //       }
  //     );
  //   }
  // }, [bookName]);

  useEffect(() => {
    let url = "";

    if (state?.bookDetailId) {
      url = `books/${state.bookDetailId}`;
    } else if (state?.kalyanDetailId) {
      url = `kalyans/${state.kalyanDetailId}`;
    } else if (state?.kalpatrauDetailId) {
      url = `kalyanskalpataru/${state.kalpatrauDetailId}`;
    } else if (state?.magazineDetailId) {
      url = `MonthlyMagazines/${state.magazineDetailId}`;
    } else if (state?.vivekvaniDetailId) {
      url = `vivekVanis/${state.vivekvaniDetailId}`;
    }

    if (url) {
      const parts = url.split("/");
      if (parts.length === 2) {
        const bookTitle = parts[0];
        const BookId = parts[1];
        const currentTime = new Date().toISOString();
        VideoService.updateUserActivity(bookTitle, BookId, currentTime);
      }
    }
  }, [state]);

  // -------------------------
  // RENDER
  // -------------------------

  return (
    <div>
      <div
        className="d-flex bd-highlight example-parent"
        id="titlebar"
        style={{ backgroundColor: "#ff8b33", color: "#ffffff" }}
      >

        <div
          className="p-2 flex-grow-1 bd-highlight col-example"
          style={{
            marginTop: "5px",
            marginLeft: "45px",
          }}
        >
          <label id="BName" style={{ fontSize: "larger" }}>
            {bookName} : {lastName}
            {saveSubHead && !isShlokWithBracket(saveSubHead)
              ? ` : ${saveSubHead.length > 180 ? saveSubHead.slice(0, 180) + "..." : saveSubHead}`
              : ""}
          </label>
        </div>

        <div className="p-2 bd-highlight col-example">
          <div style={{ flex: "100%", marginTop: "7px" }}>
            <div style={{ flex: "100%", display: "flex" }}>
              <div
                id="bookmark-list"
                style={{
                  border: "none",
                  display: showBKdata?.length < 1 ? "none" : "block",
                }}
                onClick={() => setShowdata((prev) => !prev)}
              ></div>
              <div
                id={`bkicon  ${finalName}`}
                className={isBookmarked(location) ? "bookmarkicon-fill" : "bookmarkicon"}
                onClick={() => {
                  !isBookmarked(location) ? SaveBookMark() : RemoveBookMark();
                }}
              ></div>
              <img
                alt=""
                style={{ width: "22px" }}
                src={min}
                onClick={() => {
                  changeSize(Math.max(50, size - 10));
                }}
              />
              <div
                style={{
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  fontSize: "18px",
                }}
              >
                {size}%
              </div>
              <img
                alt="plus"
                style={{ width: "22px", marginRight: "13px" }}
                src={plus}
                onClick={() => changeSize(Math.min(130, size + 10))}
              />
              <img
                alt="reload"
                style={{ width: "19px" }}
                src={reload}
                onClick={() => {
                  setTheme("#ffffff");
                  setFontColor("#000000");
                  clickOnTheme(false);
                  setThemeColor("white");
                  setSize(100);
                }}
              />
              <div
                className="icon-theme"
                onClickCapture={() => {
                  clickOnTheme(true);
                }}
              >
                <div id="theme">
                  <div id="divTheme" className="col">
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeWhite"
                        className="theme-btn-white"
                        onClick={() => {
                          setThemeColor("white");
                          setTheme("#ffffff");
                          setFontColor("#000000");
                          clickOnTheme(false);
                        }}
                      ></a>
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeIvory"
                        className="theme-btn-ivory"
                        onClick={() => {
                          setThemeColor("ivory");
                          setTheme("#fffcda");
                          setFontColor("#000000");
                          clickOnTheme(false);
                        }}
                      />
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeGrey"
                        className="theme-btn-grey"
                        onClick={() => {
                          setThemeColor("grey");
                          setTheme("#464646");
                          setFontColor("#ffffff");
                          clickOnTheme(false);
                        }}
                      />
                    </div>
                    <div className="row" style={{ margin: 0 }}>
                      <a
                        id="btnThemeBlack"
                        className="theme-btn-black"
                        onClick={() => {
                          setThemeColor("black");
                          clickOnTheme(false);
                          setTheme("#000000");
                          setFontColor("#ffffff");
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <img id="close-btn"
                alt="close"
                src={close}
                width="18px"
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  await saveLstPositionAndClose();
                  closebutton();
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        {showdata === true && lengthofbkm === true ? (
          <div
            style={{
              width: "18%",
              height: "auto",
              position: "absolute",
              right: "5px",
              zIndex: 1,
              background: "antiquewhite",
            }}
          >
            <ul className="bklistul" style={{ listStyle: "none" }}>
              {showBKdata &&
                showBKdata?.map((data: any, index: number) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      key={index}
                    >
                      <li
                        className="bklistitem"
                        key={data.id}
                        onClick={() => {
                          setLocation(data?.cfi);
                          setFinalName(data?.name);
                          manualSelectUntilRef.current =
                            Date.now() + MANUAL_GUARD_MS;
                          if (tocRef.current && data?.href) {
                            const found = findTocEntry(
                              tocRef.current,
                              data.href
                            );
                            if (found) {
                              if (found.parentLabel) {
                                setLastName(found.parentLabel);
                                setSubHeadings(found.label);
                              } else {
                                setLastName(found.label);
                                setSubHeadings("");
                              }
                            }
                          } else {
                            setLastName(data?.name || "");
                          }
                          setShowdata(false);
                        }}
                      >
                        {data?.name}
                      </li>
                      <label
                        onClick={() => {
                          handleDelete(data?.cfi);
                        }}
                        className="bookmark_del fa fa-trash"
                        style={{
                          marginRight: "40px",
                          color: "red",
                          border: "none",
                          background: "none",
                          fontSize: "24px",
                          cursor: "pointer",
                        }}
                      ></label>
                    </div>
                  );
                })}
            </ul>
          </div>
        ) : (
          <div style={{ display: "none", position: "relative" }}></div>
        )}
      </div>

      <div
        style={{
          margin: "50px 40% auto",
          textAlign: "center",
          zIndex: 1,
          position: "absolute",
        }}
      >
        {toast.show && (
          <div
            className="modal-content"
            style={{
              backgroundColor: "#FF8B33",
              color: "#fff",
              fontSize: "22px",
              fontFamily: "ChanakyaUni",
              padding: "5px 8px",
            }}
          >
            {toast.message}
          </div>
        )}
      </div>

      <div style={{ height: "93vh" }} className="myReader">
        {isSaving && <Loading message={t("saving_last_position_tr")} />}
        <EpubReader
          location={location}
          locationChanged={locationChanged}
          setSaveSubHead={handleSetSaveSubHead}
          //         subHeading={(h) =>{
          // const trimText = (text: string) =>
          //   text?.length > 20 ? text.slice(0, 20) + "..." : text;
          // setLastName(trimText(h));
          //           // setLastName(h)
          //         }}

          subHeading={(h) => {
            const trimText = (text: string) =>
              text?.length > 20 ? text.slice(0, 20) + "..." : text;
            setLastName(trimText(h));
          }}
          url={url}
          epubInitOptions={{ requestHeaders: head }}
          // onTocSelect={(
          //   label: any,
          //   subLabel: any,
          //   href?: string,
          //   cfi?: string
          // ) => {
          //   console.log(href,"aaasdfwewer")
          //   manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

          //   const finalTitle = subLabel ? `${label} : ${subLabel}` : label;

          //   if (subLabel) {
          //     setLastName(label);
          //     setSubHeadings(subLabel);
          //     setSaveSubHead(subLabel)
          //   } else {
          //     setLastName(label);
          //     setSubHeadings("");
          //     setSaveSubHead("");
          //   }
          //   setFinalName(finalTitle);

          //   if (cfi) {
          //     setLocation(cfi);
          //   } else if (href) {
          //     setLocation(href);
          //   }
          // }}

          //           onTocSelect={(label:any, subLabel:any, href?:any, cfi?:any) => {
          //   manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

          //   if (subLabel) {
          //     setLastName(label);
          //     setSubHeadings(subLabel);
          //     handleSetSaveSubHead(subLabel);
          //   } else {
          //     setLastName(label);
          //     setSubHeadings("");
          //     handleSetSaveSubHead("");
          //   }
          //   setFinalName(subLabel ? `${label} : ${subLabel}` : label);

          //   if (cfi) setLocation(cfi);
          //   else if (href) setLocation(href);
          // }}


          onTocSelect={(label: any, subLabel: any, href?: any, cfi?: any) => {
            manualSelectUntilRef.current = Date.now() + MANUAL_GUARD_MS;

            if (subLabel && !isShlokWithBracket(subLabel)) {
              setLastName(label);
              setSubHeadings(subLabel.trim());
              handleSetSaveSubHead(subLabel.trim());
              setFinalName(`${label} : ${subLabel.trim()}`);
            } else {
              setLastName(label);
              setSubHeadings("");
              handleSetSaveSubHead("");
              setFinalName(label);
            }

            if (cfi) setLocation(cfi);
            else if (href) setLocation(href);
          }}
          tocChanged={(toc: any) => {
            tocRef.current = toc;
          }}
          getRendition={(rendition) => {
            renditionRef.current = rendition;
            renditionRef.current.themes.fontSize(`${size}%`);

            // register custom theme (kept same behavior)
            rendition.themes.register("custom", {
              body: {
                padding: "20px",
                color:
                  CurrentTheme === "black" || CurrentTheme === "grey"
                    ? "#ffffff"
                    : "#000000",
                fontfamily: "ChanakyaUni",
              },
            });
            rendition.themes.select("custom");

            // ensure bookmarks are loaded once the rendition is available
            if (!bookmarksLoadedRef.current) {
              try {
                getSavedBook();
              } catch (err) {
                // ignore
              }
              bookmarksLoadedRef.current = true;
            }

            try {
              rendition.off && rendition.off("relocated", "");
            } catch (e) { }
            rendition.on &&
              rendition.on("relocated", (location: any) => {
                handleRelocated(location);
              });

            const currentLoc = rendition.location && rendition.location.start;
            if (currentLoc) {
              handleRelocated({ start: currentLoc });
            }
          }}
          epubOptions={{
            infinite: true,
            overflow: undefined,
          }}
        />
      </div>
    </div>
  );
};
export default EpubPage;
